export function RankBadge({ rank, size = "sm" }) {
  const map = {
    Nebula: "rank-nebula",
    Pulsar: "rank-pulsar",
    Quasar: "rank-quasar",
    Celestial: "rank-celestial",
  };
  const sizing = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold tracking-wider uppercase ${sizing} ${map[rank] || "rank-nebula"}`}
    >
      {rank}
    </span>
  );
}

export function TierBadge({ tier }) {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold tracking-wider bg-black/40 border border-white/10 text-zinc-300">
      <span className="text-[#D4AF37] mr-1">{tier}</span>%
    </span>
  );
}

export function RoleBadge({ role }) {
  const map = {
    sovereign: "bg-[#D4AF37]/15 text-[#D4AF37] border-[#D4AF37]/40",
    admiral: "bg-white/10 text-white border-white/20",
    junior_admiral: "bg-gradient-to-r from-rose-500/15 to-fuchsia-500/15 text-rose-200 border-rose-400/40",
    guardian: "bg-purple-500/15 text-purple-200 border-purple-400/40",
    commander: "bg-zinc-800/60 text-zinc-300 border-white/10",
  };
  const labelMap = {
    junior_admiral: "JR. ADMIRAL",
    guardian: "GUARDIAN",
  };
  const label = labelMap[role] || role;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider border ${map[role] || map.commander}`}>
      {label}
    </span>
  );
}
